export const workGlimpse = [
  {
    // TODO: replace with real client project photo
    image:
      "https://images.unsplash.com/photo-1511376979163-f804dff7ad7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHRlYW0lMjBtZWV0aW5nJTIwcG9ydHJhaXQlMjB2ZXJ0aWNhbHxlbnwwfHx8fDE3ODg0MDQ0ODl8MA&ixlib=rb-4.1.0&q=85",
    caption: "Client Project 01",
    heightClass: "h-[380px] md:h-[440px]",
  },
  {
    // TODO: replace with real client project photo
    image:
      "https://images.unsplash.com/photo-1694702740570-0a31ee1525c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBza3lzY3JhcGVyJTIwd2luZG93JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg4NDA0NDg5fDA&ixlib=rb-4.1.0&q=85",
    caption: "Client Project 02",
    heightClass: "h-[420px] md:h-[500px]",
  },
  {
    // TODO: replace with real client project photo
    image:
      "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxtYXJrZXRpbmclMjB0ZWFtJTIwY29sbGFib3JhdGlvbiUyMHdoaXRlYm9hcmR8ZW58MHx8fHwxNzg4NDA0NDg5fDA&ixlib=rb-4.1.0&q=85",
    caption: "Client Project 03",
    heightClass: "h-[360px] md:h-[420px]",
  },
  {
    // TODO: replace with real client project photo
    image:
      "https://images.unsplash.com/photo-1586232702178-f044c5f4d4b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjb250ZW50JTIwY3JlYXRvciUyMGZpbG1pbmclMjBzdHVkaW8lMjBzZXR1cHxlbnwwfHx8fDE3ODg0MDQ0ODl8MA&ixlib=rb-4.1.0&q=85",
    caption: "Client Project 04",
    heightClass: "h-[440px] md:h-[520px]",
  },
  {
    // TODO: replace with real client project photo
    image:
      "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxyZXRhaWwlMjBzdG9yZSUyMGludGVyaW9yJTIwY2xvdGhpbmclMjByYWNrfGVufDB8fHx8MTc4ODQwNDQ4OXww&ixlib=rb-4.1.0&q=85",
    caption: "Client Project 05",
    heightClass: "h-[400px] md:h-[460px]",
  },
];
